import { axios } from '@src/plugins/axios-pol'

const basePath = '/personal/api/EstadoFuerza'

export default {
  namespaced: true,

  state: {
    aspirantes: [],
    aspirantesConvertidosPolicias: [],
  },

  getters: {
    getAspirantes: (state) => {
      return state.aspirantes
    },

    getAspirantesConvertidosPolicias: (state) => {
      return state.aspirantesConvertidosPolicias
    },
  },

  mutations: {
    SET_ASPIRANTES(state, aspirantes) {
      state.aspirantes = aspirantes
    },

    SET_ASPIRANTES_CONVERTIDOS_POLICIAS(state, aspirantes) {
      state.aspirantesConvertidosPolicias = aspirantes
    },
  },

  actions: {
    fetchAspirantes: async function ({ commit }, { pageNumber, rowsOfPage }) {
      try {
        const { data } = await axios.get(`${basePath}/aspirantes/page/${pageNumber}/rowsOfPage/${rowsOfPage}`)
        const result = JSON.parse(data.data)
        commit('SET_ASPIRANTES', result)
        return result
      } catch (error) {
        console.error('Error al obtener aspirantes:', error)
        throw error
      }
    },

    fetchAspirantesConvertidosPolicias: async function ({ commit }, { pageNumber, rowsOfPage }) {
      try {
        const { data } = await axios.get(`${basePath}/reclutadosPoliciales/page/${pageNumber}/rowsOfPage/${rowsOfPage}`)
        const result = JSON.parse(data.data)
        commit('SET_ASPIRANTES_CONVERTIDOS_POLICIAS', result)
        return result
      } catch (error) {
        console.error('Error al obtener aspirantes convertidos a policías:', error)
        throw error
      }
    },

    updateAspiranteStatus: async function ({ commit }, { idPersonal, ingresoAspirante }) {
      try {
        const { data } = await axios.put(`${basePath}/personal/${idPersonal}/isAspirante`, {
          idPersonal: idPersonal,
          isAspirante: ingresoAspirante,
        })
        commit('SET_SNACKBAR_MESSAGE', 'Aspirante marcado correctamente.', { root: true })
        return true
      } catch (error) {
        console.error('Error al actualizar estatus de aspirante:', error)
        commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar aspirante.', { root: true })
        throw error
      }
    },

    updateAspiranteReclutedToPolicia: async function ({ commit }, { idPersonal, reclutadoPolicial }) {
      try {
        const { data } = await axios.put(`${basePath}/personal/${idPersonal}/culminaReclutacionPolicial`, {
          idPersonal: idPersonal,
          culminaReclutacionPolicial: reclutadoPolicial,
        })
        commit('SET_SNACKBAR_MESSAGE', 'Aspirante marcado como reclutado a policía correctamente.', { root: true })
        return true
      } catch (error) {
        if (error.response?.data?.error_code === 500) {
          commit('SET_SNACKBAR_MESSAGE', 'Reclutamiento policial actualizado correctamente.', { root: true })
          return true
        }

        console.error('Error al actualizar reclutamiento policial:', error)
        commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar reclutamiento policial.', { root: true })
        throw error
      }
    },
  },
}
